<ion-label class="ion-no-padding ion-no-margin ion-margin-horizontal" color="medium">
    <h3 [innerHtml]="label | safe: 'html'"></h3>
</ion-label>
